<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 技术与支持</p>
        <h1>技术与支持</h1>
        <p class="lede">
          自研 AIoT 云平台、AI 大模型中台、通用开发套件与配网控制 APP，
          以坚实的底层技术底座支撑敏捷开发、快速迭代。
        </p>
      </div>
    </section>

    <!-- 自研技术底座 -->
    <div class="ui-container">
      <div class="float-panel">
        <div class="tech-grid">
          <div class="tech" v-for="t in techPlatforms" :key="t.name">
            <div class="tech__pic">
              <img :src="t.image" :alt="t.name" />
            </div>
            <h3>{{ t.name }}</h3>
            <p>{{ t.desc }}</p>
            <ul class="check-list">
              <li v-for="pt in t.points" :key="pt">{{ pt }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 开发者与客户支持 -->
    <section class="section">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">SUPPORT</span>
          <h2>开发者与客户支持</h2>
          <p class="sub">在线工具与平台入口，一站式搞定固件升级与设备管理</p>
        </div>
        <div class="sup-grid">
          <div class="sup card" v-for="s in techSupports" :key="s.name">
            <div class="sup__pic">
              <img :src="s.image" :alt="s.name" />
            </div>
            <div class="sup__body">
              <h3>{{ s.name }}</h3>
              <p>{{ s.desc }}</p>
              <a
                class="btn btn--sm"
                :class="isExt(s) ? 'btn--primary' : 'btn--ghost'"
                :href="s.href"
                :target="isExt(s) ? '_blank' : '_self'"
                :rel="isExt(s) ? 'noopener noreferrer' : null"
              >{{ s.linkText }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作模式 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">COOPERATION</span>
          <h2>合作模式与价值</h2>
          <p class="sub">灵活共赢，降低成本</p>
        </div>
        <div class="coop-grid">
          <div class="coop card" v-for="(c, i) in cooperationModes" :key="c.name">
            <span class="coop__num">0{{ i + 1 }}</span>
            <h3>{{ c.name }}</h3>
            <p>{{ c.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { techPlatforms, techSupports, cooperationModes } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        techPlatforms,
        techSupports,
        cooperationModes
      };
    },
    methods: {
      isExt(s) {
        return s.href.indexOf("http") === 0;
      }
    }
  };
</script>

<style scoped>
  .tech-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
  .tech__pic {
    height: 150px;
    border-radius: 12px;
    overflow: hidden;
    background: #fdeceb;
    border: 1px solid #f6e0dd;
  }
  .tech__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;  
    display: block;
  }
  .tech h3 { margin-top: 14px; font-size: 17px; }
  .tech p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.7;
  }
  .tech .check-list { margin-top: 10px; }
  .tech .check-list li { font-size: 13px; }

  .sup-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }
  .sup { padding: 0; overflow: hidden; display: flex; flex-direction: column; }
  .sup__pic {
    height: 170px;
    background: #fdeceb;
    overflow: hidden;
  }
  .sup__pic img {
    width: 100%;  
    height: 100%;
    object-fit: cover;  
    display: block;
  }
  .sup__body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 20px 24px 24px;
  }
  .sup h3 { font-size: 17px; }
  .sup p {
    margin: 8px 0 16px;
    font-size: 13px;
    color: #8a909b;
    line-height: 1.75;
    flex: 1;
  }
  .sup .btn { align-self: flex-start; }

  .coop-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }
  .coop { padding: 28px 26px; }
  .coop__num {
    font-size: 30px;
    font-weight: 800;
    color: #f6b6b0;
  }
  .coop h3 { margin-top: 8px; font-size: 17px; }
  .coop p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  @media (max-width: 1023px) {
    .tech-grid { grid-template-columns: repeat(2, 1fr); }
    .sup-grid,
    .coop-grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .tech-grid,
    .sup-grid,
    .coop-grid { grid-template-columns: 1fr; }
  }
</style>
